<template>
	<div class="top-list">
		<div
			class="box"
			v-for="(item, index) in chooseList" :key="index"
			:style="{backgroundColor: item.path === chenLieType ? '#264EA7' : '', color: item.path === chenLieType ? '#EDD68E' : '#686868'}"
			@click="changeIndex(item)"
			>
			{{item.name}}
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		data () {
			return {

			}
		},
		computed: {
			chenLieType() {
				return this.$store.state.chenLieType
			},
			chooseList() {
				return this.$store.state.secondList[0].children
			},
		},
		created() {
			this.chooseList.some(item => {
				if(item.path === this.chenLieType) {
					this.$store.state.channelId = item.id
				}
			})
		},
		methods: {
			changeIndex(item) {
				let that = this
				if(item.path === that.chenLieType) {
					return
				}
				that.$store.state.chenLieType = item.path
				that.$store.state.channelId = item.id
				that.$router.push('clzl')
				that.$emit('changeTab')
			},
		}

	}
</script>

<style lang="less" scoped>
	.top-list {
		display: flex;
		width: 80%;
		margin: 35px 10%;
		justify-content: center;
		.box {
			padding: 5px 12px;
			font-size: 16px;
			margin: 0 45px;
			cursor: pointer;
			border-radius: 2px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/ChenLieNav.vue